import { Card, Stack, SxProps, Typography } from "@mui/material";
import { ReactNode } from "react";

export default function BoxCard({
  sx,
  title,
  children,
}: {
  sx?: SxProps;
  title: string;
  children: ReactNode | ReactNode[];
}) {
  return (
    <Card elevation={1} sx={{ p: 3, ...sx }}>
      <Stack spacing={2}>
        <Typography sx={{ fontWeight: "bold" }}>{title}</Typography>
        {children}
      </Stack>
    </Card>
  );
}
